import React, { useState } from 'react';
import styles from '../styles/Navigation.module.css';

function Navigation() {
    const [isMenuOpen, setIsMenuOpen] = useState(false);

    const navItems = [
        { name: 'Home', href: '#about' },
        { name: 'Skills', href: '#skills' },
        { name: 'Experience', href: '#experience' },
        { name: 'Projects', href: '#projects' },
        { name: 'Testimonials', href: '#testimonials' },
        { name: 'Contact', href: '#contact' }
    ];

    return (
        <nav className={styles.navigation}>
            <div className={styles.navContainer}>
                <a href="#home" className={styles.gradientEffect}>"...scriptum novum..!"</a>

                <ul className={`${styles.navMenu} ${isMenuOpen ? styles.mobileMenu : ''}`}>
                    {navItems.map((item, index) => (
                        <li key={index} className={styles.navItem}>
                            <a
                                href={item.href}
                                onClick={() => setIsMenuOpen(false)}
                            >
                                {item.name}
                            </a>
                        </li>
                    ))}
                </ul>

                <div
                    className={styles.menuToggle}
                    onClick={() => setIsMenuOpen(!isMenuOpen)}
                >
                    <span></span>
                    <span></span>
                    <span></span>
                </div>
            </div>
        </nav>
    );
}

export default Navigation;